const state = {
  objeto: {
    name: 'Nome',
    email: 'Email',
    cnpj: 'CNPJ',
    projeto: '/',
    token: 'Token'
  }
}

const mutations = {
  updateUserAtual (state, res) {
    state.objeto = res.data
  },
  fillDataUser (state, res) {
    state.objeto.name = res.data.nome
    state.objeto.email = res.data.email
    state.objeto.cnpj = res.data.cnpj
    state.objeto.projeto = res.data.projeto
    state.objeto.token = res.data.token
    window.axios.defaults.headers.common['Authorization'] = res.data.token
    window.localStorage.setItem('token', res.data.token)
    window.localStorage.setItem('empresa', res.data.cnpj)
    window.localStorage.setItem('projeto', res.data.projeto)
  }
}

const actions = {
  updateUser (context, data) {
    var id = data.id
    let qs = require('querystring')
    var dados = qs.stringify(data.turno)
    return window.axios.put('/api/v2/turnos/' + id, dados).then((res) => {
      return res
    })
  },
  loginUser (context, data) {
    return window.axios.post('/auth/token', data).then((res) => {
      context.commit('fillDataUser', res)
      return res
    })
  },
  logoutUser (context, data) {
    state.objeto.name = null
    state.objeto.email = null
    state.objeto.cnpj = null
    state.objeto.projeto = ''
    state.objeto.token = null
    window.localStorage.setItem('token', null)
    window.localStorage.setItem('user', null)
    window.localStorage.setItem('empresa', null)
    window.localStorage.setItem('monitores', null)
    window.localStorage.setItem('monitoramento', null)
    window.localStorage.setItem('projeto', null)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Users.js